import React from 'react';
import './PopupComponent.css';
import android from '../../assets/images/play-store-icon.png'

const AndroidPopupComponent = ({ isModalOpenAndroid, onLoginClick }) => {
  if (!isModalOpenAndroid) return null;

  return (
    <div
      id="divMobileAppAlertAndroid"
      className="d-flex justify-content-center align-items-center popup-overlay"
    >
      <div className="popup-container">
        <div className="popup-header">
          <h2 className="popup-title">Download Inmate Mobile App</h2>
        </div>
        <div className="popup-body">
          <div className="form-group mb-2">
            <p className="popup-message">
              Discover more, connect faster, and enjoy personalized benefits! Download our app today for seamless access to exclusive content,
              personalized recommendations, and convenient features tailored just for you.
            </p>
          </div>
          <div className="flex social-btns">
            <a
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',


              }}
              href="https://play.google.com/store/apps/details?id=io.inmateinbox.inmateinbox&hl=en_US&gl=US&pli=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={android} alt="Google Play Logo" style={{ height: '70px', marginRight: '' }} />
              <divider />
            </a>
          </div>
          <div className='mt-3' style={{ width: '100%', borderTop: '1px solid #507193' }}></div>
        </div>
        <div className="popup-footer">
          <button onClick={onLoginClick} className="btn btn-danger font-size-14 liner-button">
            SKIP
          </button>
        </div>
      </div>
    </div>
  );
};

export default AndroidPopupComponent;
